module.exports = __webpack_public_path__ + "static/media/blocked-players-active-dark-icon.6364bbdc.svg";